import stylus from './index.module.styl'
import * as T from '@/types'

const filtered = (Object.entries(stylus) as [ string, string ][])
    .filter(([ key, value ]) => {
        return key.charAt(0) === '$'
    })
const numbersParsed = filtered
    .map(([ key, value ]) => {
        const parsedValue = parseInt(value)
        const parsedValueAsNumber = isNaN(parsedValue) ? value : parsedValue
        return [ key, parsedValueAsNumber ]
    })
const asObject = numbersParsed
    .reduce((previous, [ key, value ]) => {
        previous[key] = value
        return previous
    }, ({} as T.Dictionary<string | number>))

export default asObject
